<template>
	<div class="TypePreview">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img src="~@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.push('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a class="active">预习模式</a>
		</div>
		<!-- 内容 -->
		<div class="contain">
			<p class="title">{{articlinfo.title}}</p>
			<div v-html="article"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PersonalCenter",
	data() {
		return {
			articlinfo: {},
			article:''
		};
	},
	mounted() {
		this.getArticle();
	},
	methods:{
		async getArticle(){
			const res = await this.$http.get('api/article/getArticle');
			this.article = res.result.content;
			// console.log('url',article.replace(/..\/..\/../g,'https://treasure.9shadow.com'));
			// this.article = article.replace(/..\/..\/../g,'https://treasure.9shadow.com');
			this.articlinfo = res.result;
		}
	}
};
</script>

<style lang="less" scoped>
.TypePreview {
	overflow: auto;
	.Breadcrumb {
		width: 100%;
		position: fixed;
		height: 66px;
		background: #fff1d1;
		padding-left: 38px;
		display: flex;
		justify-content: start;
		z-index: 10;
		> img {
			width: 66px;
			height: 66px;
		}
		a {
			line-height: 66px;
			font-size: 25px;
			font-weight: 400;
			color: rgba(0, 0, 0, 0.45);
		}
		a.active {
			color: #ffa216;
		}
	}
	.contain {
        padding: 0 20px;
		// width: 1705px;
		margin: auto;
		margin-top: 66px;
		.title {
			font-size: 40px;
			font-weight: bold;
			line-height: 80px;
			color: #313131;
			text-align: center;
			margin: 0;
		}
	}
}
</style>
